/** Public path set with --public-path=... in Piral CLI */
export function getPublicPath(): string {
  return process.env['PIRAL_PUBLIC_PATH'] || '/';
}
